import React from 'react';
import { Section } from './ui/Section';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { ArrowDown } from 'lucide-react';
export function Mechanism() {
  return <Section background="light" className="relative overflow-hidden" data-id="element-98">
      <FadeIn data-id="element-99">
        <div className="text-center mb-12" data-id="element-100">
          <span className="text-[#1B4332] font-semibold tracking-wider uppercase text-sm mb-2 block" data-id="element-101">
            El Mecanismo Único
          </span>
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-102">
            ECT + Semáforo del Dolor
          </h2>
          <p className="text-lg max-w-2xl mx-auto" data-id="element-103">
            Rodilla Sin Miedo está construido como un sistema simple para que
            sepas exactamente qué hacer.
          </p>
        </div>
      </FadeIn>

      {/* "Semáforo del dolor" image */}
      <FadeIn delay={0.1} data-id="element-104">
        <div className="mb-12 rounded-2xl overflow-hidden shadow-lg max-w-lg mx-auto" data-id="element-105">
          <img src="https://cdn.magicpatterns.com/uploads/sQGVMd8KFxfJLSme27FoRx/heylloyd-image-1770617029853.png" alt="Semáforo del dolor — avanzá sin recaídas" className="w-full h-auto object-cover" data-id="element-106" />
        </div>
      </FadeIn>

      <div className="grid md:grid-cols-2 gap-8 items-start" data-id="element-107">
        {/* Semáforo */}
        <FadeIn delay={0.2} className="bg-white p-8 rounded-2xl shadow-lg border border-[#D8F3DC]" data-id="element-108">
          <h3 className="text-2xl font-bold mb-6 text-[#1B4332] flex items-center" data-id="element-109">
            <span className="mr-3 text-3xl" data-id="element-110">🚦</span>
            Semáforo del Dolor
          </h3>
          <p className="mb-6 text-gray-600" data-id="element-111">
            Una regla práctica para decidir cuándo avanzar, cuándo ajustar y
            cuándo retroceder sin culpa.
          </p>

          <div className="space-y-4" data-id="element-112">
            <div className="flex items-center p-3 rounded-lg bg-green-50 border border-green-100" data-id="element-113">
              <div className="w-4 h-4 rounded-full bg-green-500 mr-3 shadow-sm shadow-green-500/50" data-id="element-114" />
              <span className="font-medium text-green-900" data-id="element-115">
                Verde: Avanzar (Seguro)
              </span>
            </div>
            <div className="flex items-center p-3 rounded-lg bg-yellow-50 border border-yellow-100" data-id="element-116">
              <div className="w-4 h-4 rounded-full bg-yellow-500 mr-3 shadow-sm shadow-yellow-500/50" data-id="element-117" />
              <span className="font-medium text-yellow-900" data-id="element-118">
                Amarillo: Ajustar (Precaución)
              </span>
            </div>
            <div className="flex items-center p-3 rounded-lg bg-red-50 border border-red-100" data-id="element-119">
              <div className="w-4 h-4 rounded-full bg-red-500 mr-3 shadow-sm shadow-red-500/50" data-id="element-120" />
              <span className="font-medium text-red-900" data-id="element-121">
                Rojo: Retroceder (Alto)
              </span>
            </div>
          </div>

          <p className="mt-6 text-sm font-medium text-center text-gray-500 italic" data-id="element-122">
            "Porque la mayoría no se rompe por hacer poco. Se rompe por hacer
            mal."
          </p>
        </FadeIn>

        {/* ECT */}
        <FadeIn delay={0.3} className="bg-white p-8 rounded-2xl shadow-lg border border-[#D8F3DC]" data-id="element-123">
          <h3 className="text-2xl font-bold mb-6 text-[#1B4332] flex items-center" data-id="element-124">
            <span className="mr-3 text-3xl" data-id="element-125">📈</span>
            Escalera de Carga (ECT)
          </h3>
          <p className="mb-6 text-gray-600" data-id="element-126">
            En vez de "metele", tenés niveles claros. Solo subís cuando el
            cuerpo lo aprueba.
          </p>

          <div className="relative pl-4 space-y-8 before:absolute before:left-0 before:top-2 before:bottom-2 before:w-0.5 before:bg-gray-200" data-id="element-127">
            <div className="relative" data-id="element-128">
              <div className="absolute -left-[21px] top-1 w-3 h-3 rounded-full bg-[#1B4332] ring-4 ring-white" data-id="element-129" />
              <h4 className="font-bold text-[#1B4332]" data-id="element-130">Nivel 0</h4>
              <p className="text-sm text-gray-600" data-id="element-131">
                Calmar + activar sin irritar
              </p>
            </div>
            <div className="relative" data-id="element-132">
              <div className="absolute -left-[21px] top-1 w-3 h-3 rounded-full bg-[#2D6A4F] ring-4 ring-white" data-id="element-133" />
              <h4 className="font-bold text-[#2D6A4F]" data-id="element-134">Nivel 1</h4>
              <p className="text-sm text-gray-600" data-id="element-135">
                Estabilidad básica para la vida diaria
              </p>
            </div>
            <div className="relative" data-id="element-136">
              <div className="absolute -left-[21px] top-1 w-3 h-3 rounded-full bg-[#40916C] ring-4 ring-white" data-id="element-137" />
              <h4 className="font-bold text-[#40916C]" data-id="element-138">Nivel 2</h4>
              <p className="text-sm text-gray-600" data-id="element-139">
                Fuerza útil (silla, escalón bajo, caminata)
              </p>
            </div>
          </div>
        </FadeIn>
      </div>

      <FadeIn delay={0.4} className="mt-12 text-center" data-id="element-140">
        <Button size="lg" onClick={() => document.getElementById('checkout')?.scrollIntoView({
        behavior: 'smooth'
      })} data-id="element-141">
          Quiero aplicar este sistema
        </Button>
      </FadeIn>
    </Section>;
}